import { getMemberType } from './memberships';
import { isMember as isOrgMember } from '@trello/organizations';

export const canEdit = (
  member: Parameters<typeof getMemberType>[0],
  board: Parameters<typeof getMemberType>[1] & {
    prefs?: {
      selfJoin?: boolean;
    } | null;
  },
) => {
  const memberType = getMemberType(member, board);

  if (['admin', 'normal'].includes(memberType)) {
    return true;
  }

  if (board.prefs?.selfJoin && board.organization) {
    if (isOrgMember(member, board.organization)) {
      return true;
    }
  }
  return false;
};
